
export default class PhoneService {

    phones=[
        {
            name: 'Xiaomi mi a1',
            price: 300,
            urlImage: '/image/3.jpg',
            id: 1,
            attr:['Black', 'Blue' , 'Gold'],
            description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quidem eos modi adipisci cupiditate culpa distinctio porro ad sit at dolorem."
        },
        {
            name: 'Samsung s10 note',
            price: 1000,
            urlImage: '/image/2.jpg',
            id:2,
            attr:['Black', 'Blue' , 'Gold' , 'Silver'],
            description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quidem eos modi adipisci cupiditate culpa distinctio porro ad sit at dolorem."
        },
        {
            name: 'Honor p20',
            price: 400,
            urlImage: '/image/3.jpg',
            id:3,
            attr:['Black', 'Blue'],
            description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quidem eos modi adipisci cupiditate culpa distinctio porro ad sit at dolorem."
        },
        {
            name: 'Honor p30',
            price: 500,
            urlImage: '/image/3.jpg',
            id:4,
            attr:['Black', 'Blue'],
            description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quidem eos modi adipisci cupiditate culpa distinctio porro ad sit at dolorem."
        }
    ]

    getList=()=>{
        let data=this.phones.map(this.transformPhone);
        return new Promise((resolve , reject)=>{
            setTimeout(()=>{
                resolve(data);
                // reject(new Error('Something bad happened'));
            } , 300);
        });
    }
    getPhone=(id)=>{
        let obj={};
        this.phones.forEach((item)=>{
            if(item.id==id){
                obj=item;
            }   
        });
        return new Promise((resolve , reject)=>{
            setTimeout(()=>{
               resolve(obj);
            //    reject(new Error('Something bad happened'));
            }, 300);
        });

    }

    transformPhone=(item)=>{
        return {
            name:item.name,
            price: item.price,
            urlImage: item.urlImage,
            id: item.id
        }
    }
}